import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import "./ErrorModal.css";

const ErrorModal = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="error-overlay">
      <div className="error-box">
        <button className="error-close" onClick={onClose}>
          ×
        </button>
        <FaExclamationTriangle className="error-icon" />
        <h4>¡Error!</h4>
        <p className="error-message">{message}</p>
        <button className="error-btn" onClick={onClose}>
          Entendido
        </button>
      </div>
    </div>
  );
};

export default ErrorModal;
